import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

const UPDATE_NOTIFICATION = '/v2/user/notifications';
const UPDATE_NOTIFICATIONS = '/v2/notifications/mark-all-read';

export interface UpdateNotificationResponse {
  notifications: Notification;
}
export interface UpdateNotificationBody {
  isRead: number;
  id: number | undefined;
}
export const updateNotificationStatus = ({
  isRead,
  id,
}: UpdateNotificationBody) => {
  return httpClient.put<UpdateNotificationResponse>(
    `${UPDATE_NOTIFICATION}/${id}`,
    {
      'is-read': isRead,
    },
  );
};

export const useUpdateNotificationStatus = (
  params?: UseMutationOptions<
    AxiosResponse<UpdateNotificationResponse>,
    AxiosError<any>,
    UpdateNotificationBody
  >,
) => {
  return useMutation<
    AxiosResponse<UpdateNotificationResponse>,
    AxiosError<any>,
    UpdateNotificationBody
  >(updateNotificationStatus, params);
};
export const updateAllNotificationStatus = () => {
  return httpClient.post<UpdateNotificationResponse>(UPDATE_NOTIFICATIONS);
};
export const useUpdateAllNotificationStatus = () => {
  return useMutation(updateAllNotificationStatus);
};
